/* === Verarus AI Chat Widget v2 === */
(function(){
  if (window.VerarusAIChat) return;
  window.VerarusAIChat = true;

  const WORKER_URL = 'https://verarus-ai-chat.verarus-official.workers.dev/';
  const STORAGE_KEY = 'vac_history_v1';
  const SESSION_KEY = 'vac_session_v1';

  function getSessionId(){
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,10);
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  }

  function getLocale(){
    return (document.documentElement.lang || document.documentElement.getAttribute('lang') || 'ja-JP').toLowerCase();
  }

  function getGreeting(){
    const l = getLocale();
    if (l.startsWith('ko')) return {
      title: 'VERARUS 고객지원',
      greet: '안녕하세요! VERARUS 입니다. 무엇을 도와드릴까요?',
      suggestions: ['사이즈 추천', '배송 안내', '반품·교환', '쿠폰 사용법'],
      placeholder: '메시지를 입력하세요...',
      credit: 'VERARUS AI'
    };
    if (l.startsWith('en')) return {
      title: 'VERARUS Support',
      greet: 'Hi! How can VERARUS help you today?',
      suggestions: ['Size guide', 'Shipping', 'Returns', 'Coupon help'],
      placeholder: 'Type your message...',
      credit: 'VERARUS AI'
    };
    return {
      title: 'VERARUS サポート',
      greet: 'こんにちは！VERARUSです。お気軽にお問い合わせください。',
      suggestions: ['サイズの選び方', '配送について', '返品・交換', 'クーポンの使い方'],
      placeholder: 'メッセージを入力...',
      credit: 'VERARUS AI'
    };
  }

  let history = [];
  try { history = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || []; } catch(e){}
  function saveHistory(){
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(-30))); } catch(e){}
  }

  function init(){
    const t = getGreeting();
    if (document.getElementById('vac-launcher')) return;

    const launcher = document.createElement('button');
    launcher.id = 'vac-launcher';
    launcher.type = 'button';
    launcher.setAttribute('aria-label','Chat with us');
    launcher.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2z" fill="currentColor"/></svg>';

    const panel = document.createElement('div');
    panel.id = 'vac-panel';
    panel.setAttribute('role','dialog');
    panel.innerHTML = `
      <div class="vac-header">
        <div class="vac-header-title"><span class="vac-dot"></span>${t.title}</div>
        <button class="vac-close" type="button" aria-label="close">✕</button>
      </div>
      <div class="vac-body" id="vac-body"></div>
      <div class="vac-credit">Powered by ${t.credit}</div>
      <div class="vac-footer">
        <textarea class="vac-input" id="vac-input" placeholder="${t.placeholder}" rows="1" autocapitalize="off" autocomplete="off"></textarea>
        <button class="vac-send" id="vac-send" type="button" aria-label="send"><svg viewBox="0 0 24 24" fill="none"><path d="M3 11L21 3l-8 18-2-8-8-2z" fill="currentColor"/></svg></button>
      </div>
    `;

    // Important: append at the very end of body, outside any wrapper
    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    const body = panel.querySelector('#vac-body');
    const input = panel.querySelector('#vac-input');
    const send = panel.querySelector('#vac-send');
    const closeBtn = panel.querySelector('.vac-close');

    function render(){
      body.innerHTML = '';
      if (history.length === 0){
        addMessageElem(t.greet, 'bot');
        const sg = document.createElement('div');
        sg.className = 'vac-suggestions';
        t.suggestions.forEach(s => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'vac-suggestion';
          b.textContent = s;
          b.onclick = (e) => { e.preventDefault(); input.value = s; submit(); };
          sg.appendChild(b);
        });
        body.appendChild(sg);
      } else {
        history.forEach(m => addMessageElem(m.content, m.role === 'user' ? 'user' : 'bot'));
      }
      scrollBottom();
    }

    function addMessageElem(text, who){
      const d = document.createElement('div');
      d.className = 'vac-msg vac-' + who;
      let safe = String(text).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      // bold
      safe = safe.replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>');
      // markdown link [text](url)
      safe = safe.replace(/\[([^\]]+)\]\((https?:[^\)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      // auto-link 公式LINE → href (JP only)
      if (who === 'bot' && safe.indexOf('公式LINE') !== -1) {
        safe = safe.replace(/公式LINE/g, '<a href="https://lin.ee/WQ3SKK5" target="_blank" rel="noopener noreferrer">公式LINE</a>');
      }
      // auto-link plain email
      safe = safe.replace(/(?<!["'>])(support@verarus\.com)(?!<)/g, '<a href="mailto:$1">$1</a>');
      d.innerHTML = safe;
      body.appendChild(d);
      return d;
    }
    function scrollBottom(){ requestAnimationFrame(() => { body.scrollTop = body.scrollHeight; }); }

    function showTyping(){
      const d = document.createElement('div');
      d.className = 'vac-typing';
      d.id = 'vac-typing';
      d.innerHTML = '<span></span><span></span><span></span>';
      body.appendChild(d);
      scrollBottom();
      return d;
    }

    async function submit(){
      const text = input.value.trim();
      if (!text) return;
      input.value = '';
      input.style.height = 'auto';
      send.disabled = true;
      const sg = body.querySelector('.vac-suggestions');
      if (sg) sg.remove();
      history.push({role:'user', content:text});
      addMessageElem(text, 'user');
      saveHistory();
      scrollBottom();
      const typing = showTyping();
      try {
        const res = await fetch(WORKER_URL, {
          method: 'POST',
          headers: {'content-type':'application/json'},
          body: JSON.stringify({ messages: history, locale: getLocale(), session_id: getSessionId(), page_url: location.href })
        });
        const data = await res.json();
        typing.remove();
        if (data && data.reply){
          history.push({role:'assistant', content:data.reply});
          addMessageElem(data.reply, 'bot');
          saveHistory();
        } else {
          addMessageElem('エラー: 応答を取得できませんでした。再度お試しください。', 'bot');
        }
      } catch(e){
        typing.remove();
        addMessageElem('接続エラー: しばらく経ってから再度お試しください。', 'bot');
      } finally {
        send.disabled = false;
        scrollBottom();
      }
    }

    launcher.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      const opened = panel.classList.toggle('vac-open');
      if (opened) {
        render();
        setTimeout(() => input.focus(), 100);
      }
    });
    closeBtn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      panel.classList.remove('vac-open');
    });
    send.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      submit();
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey){
        e.preventDefault();
        submit();
      }
    });
    input.addEventListener('input', () => {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 100) + 'px';
    });
    // Ensure input is clickable
    input.addEventListener('focus', (e) => { e.stopPropagation(); });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
